import { useCallback, useId } from 'react';
import { useControllable } from '../../hooks';
import { makeId } from '../../utils';
export function useDisclosure({
  id,
  open: openProp,
  defaultOpen = false,
  onOpenChange
} = {}) {
  const genId = useId();
  const contentId = makeId('disclosure', id || genId);
  const [open, setOpen] = useControllable({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen(v => !v), [open]);
  const triggerProps = {
    'aria-controls': contentId,
    'aria-expanded': open,
    onClick: toggle
  };
  const contentProps = {
    id: contentId,
    hidden: !open
  };
  return {
    open,
    show,
    close,
    toggle,
    setOpen,
    contentId,
    triggerProps,
    contentProps
  };
}